/* tslint:disable */
/* eslint-disable */
/**
 * Bank Backoffice Gateway – Campaigns, external
 * Partner\'s Bank Backoffice Gateway for Campaigns, external
 *
 * The version of the OpenAPI document: 1.4
 * Contact: radomil.janicek@partnersbanka.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// URLSearchParams not necessarily used
// @ts-ignore

// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction,
    type EndpointOptions, // THIS IS CUSTOM
  } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @enum {string}
 */

export const AffectedCampaignTypeRequestV1 = {
    BUNDLE_DISCOUNT: 'BUNDLE_DISCOUNT',
    INTEREST_RATE: 'INTEREST_RATE'
} as const;

export type AffectedCampaignTypeRequestV1 = typeof AffectedCampaignTypeRequestV1[keyof typeof AffectedCampaignTypeRequestV1];


/**
 * 
 * @export
 * @enum {string}
 */

export const AffectedCampaignTypeResponseV1 = {
    BUNDLE_DISCOUNT: 'BUNDLE_DISCOUNT',
    INTEREST_RATE: 'INTEREST_RATE',
    OTHER: 'OTHER'
} as const;

export type AffectedCampaignTypeResponseV1 = typeof AffectedCampaignTypeResponseV1[keyof typeof AffectedCampaignTypeResponseV1];


/**
 * 
 * @export
 * @enum {string}
 */

export const AffectedProductGroupTypeV1 = {
    BUNDLE: 'BUNDLE',
    SAVINGS: 'SAVINGS',
    CURRENT: 'CURRENT',
    OTHER: 'OTHER'
} as const;

export type AffectedProductGroupTypeV1 = typeof AffectedProductGroupTypeV1[keyof typeof AffectedProductGroupTypeV1];


/**
 * 
 * @export
 * @interface AffectedProductV1
 */
export interface AffectedProductV1 {
    /**
     * 
     * @type {string}
     * @memberof AffectedProductV1
     */
    'productType': string;
    /**
     * 
     * @type {string}
     * @memberof AffectedProductV1
     */
    'productInstanceUuid': string;
    /**
     * 
     * @type {string}
     * @memberof AffectedProductV1
     */
    'iban'?: string;
    /**
     * 
     * @type {string}
     * @memberof AffectedProductV1
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface AmountIsoCurrencyV2x4
 */
export interface AmountIsoCurrencyV2x4 {
    /**
     * 
     * @type {number}
     * @memberof AmountIsoCurrencyV2x4
     */
    'value': number;
    /**
     * 
     * @type {string}
     * @memberof AmountIsoCurrencyV2x4
     */
    'currencyCode': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AppliedToClientsV1 = {
    INDIVIDUAL: 'INDIVIDUAL',
    BUNDLE: 'BUNDLE',
    OTHER: 'OTHER'
} as const;

export type AppliedToClientsV1 = typeof AppliedToClientsV1[keyof typeof AppliedToClientsV1];


/**
 * 
 * @export
 * @enum {string}
 */

export const BrokerageDiscountTypeV1 = {
    ACQUISITION: 'ACQUISITION',
    SUBSEQUENT: 'SUBSEQUENT',
    OTHER: 'OTHER'
} as const;

export type BrokerageDiscountTypeV1 = typeof BrokerageDiscountTypeV1[keyof typeof BrokerageDiscountTypeV1];


/**
 * 
 * @export
 * @interface BundleDiscountShortV1
 */
export interface BundleDiscountShortV1 {
    /**
     * 
     * @type {number}
     * @memberof BundleDiscountShortV1
     */
    'discountPercent': number;
}
/**
 * 
 * @export
 * @interface BundleDiscountV1
 */
export interface BundleDiscountV1 {
    /**
     * 
     * @type {number}
     * @memberof BundleDiscountV1
     */
    'discountPercent': number;
    /**
     * 
     * @type {AmountIsoCurrencyV2x4}
     * @memberof BundleDiscountV1
     */
    'originalPriceValue': AmountIsoCurrencyV2x4;
}
/**
 * 
 * @export
 * @interface CampaignDescriptionV1
 */
export interface CampaignDescriptionV1 {
    /**
     * 
     * @type {string}
     * @memberof CampaignDescriptionV1
     */
    'campaignTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignDescriptionV1
     */
    'campaignName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignDescriptionV1
     */
    'campaignDescription'?: string;
}
/**
 * 
 * @export
 * @interface CampaignListItemV1
 */
export interface CampaignListItemV1 {
    /**
     * 
     * @type {string}
     * @memberof CampaignListItemV1
     */
    'campaignCode': string;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignListItemV1
     */
    'availableForFip': boolean;
    /**
     * 
     * @type {number}
     * @memberof CampaignListItemV1
     */
    'totalNumberOfSpecifications': number;
    /**
     * 
     * @type {Array<CampaignSpecificationShortV1>}
     * @memberof CampaignListItemV1
     */
    'campaignSpecifications': Array<CampaignSpecificationShortV1>;
}
/**
 * 
 * @export
 * @interface CampaignSpecificationDetailIdentificationV1
 */
export interface CampaignSpecificationDetailIdentificationV1 {
    /**
     * 
     * @type {LanguageV1}
     * @memberof CampaignSpecificationDetailIdentificationV1
     */
    'language': LanguageV1;
    /**
     * 
     * @type {string}
     * @memberof CampaignSpecificationDetailIdentificationV1
     */
    'campaignSpecificationUuid': string;
}


/**
 * 
 * @export
 * @interface CampaignSpecificationDetailV1
 */
export interface CampaignSpecificationDetailV1 {
    /**
     * 
     * @type {string}
     * @memberof CampaignSpecificationDetailV1
     */
    'campaignCode': string;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignSpecificationDetailV1
     */
    'availableForFip': boolean;
    /**
     * 
     * @type {number}
     * @memberof CampaignSpecificationDetailV1
     */
    'brokerageDiscountPercent'?: number;
    /**
     * 
     * @type {BrokerageDiscountTypeV1}
     * @memberof CampaignSpecificationDetailV1
     */
    'brokerageDiscountType'?: BrokerageDiscountTypeV1;
    /**
     * 
     * @type {AppliedToClientsV1}
     * @memberof CampaignSpecificationDetailV1
     */
    'appliedToClients': AppliedToClientsV1;
    /**
     * 
     * @type {CampaignSpecificationV1}
     * @memberof CampaignSpecificationDetailV1
     */
    'campaignSpecification': CampaignSpecificationV1;
}


/**
 * 
 * @export
 * @interface CampaignSpecificationShortV1
 */
export interface CampaignSpecificationShortV1 {
    /**
     * 
     * @type {string}
     * @memberof CampaignSpecificationShortV1
     */
    'campaignSpecificationUuid': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignSpecificationShortV1
     */
    'campaignSpecificationCode': string;
    /**
     * 
     * @type {AffectedCampaignTypeResponseV1}
     * @memberof CampaignSpecificationShortV1
     */
    'affectedCampaignType': AffectedCampaignTypeResponseV1;
    /**
     * 
     * @type {CampaignStatusV1}
     * @memberof CampaignSpecificationShortV1
     */
    'specificationStatus': CampaignStatusV1;
    /**
     * 
     * @type {string}
     * @memberof CampaignSpecificationShortV1
     */
    'activeFrom': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignSpecificationShortV1
     */
    'activeTo': string;
    /**
     * 
     * @type {InterestRateShortV1}
     * @memberof CampaignSpecificationShortV1
     */
    'interestRate'?: InterestRateShortV1;
    /**
     * 
     * @type {BundleDiscountShortV1}
     * @memberof CampaignSpecificationShortV1
     */
    'bundleDiscount'?: BundleDiscountShortV1;
    /**
     * 
     * @type {CampaignDescriptionV1}
     * @memberof CampaignSpecificationShortV1
     */
    'campaignDescription'?: CampaignDescriptionV1;
}


/**
 * 
 * @export
 * @interface CampaignSpecificationV1
 */
export interface CampaignSpecificationV1 {
    /**
     * 
     * @type {string}
     * @memberof CampaignSpecificationV1
     */
    'campaignSpecificationUuid': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignSpecificationV1
     */
    'campaignSpecificationCode': string;
    /**
     * 
     * @type {AffectedCampaignTypeResponseV1}
     * @memberof CampaignSpecificationV1
     */
    'affectedCampaignType': AffectedCampaignTypeResponseV1;
    /**
     * 
     * @type {AffectedProductGroupTypeV1}
     * @memberof CampaignSpecificationV1
     */
    'affectedProductGroupType'?: AffectedProductGroupTypeV1;
    /**
     * 
     * @type {Array<string>}
     * @memberof CampaignSpecificationV1
     */
    'affectedProductTypes'?: Array<string>;
    /**
     * 
     * @type {Array<AffectedProductV1>}
     * @memberof CampaignSpecificationV1
     */
    'affectedProducts'?: Array<AffectedProductV1>;
    /**
     * 
     * @type {InterestRateV1}
     * @memberof CampaignSpecificationV1
     */
    'interestRate'?: InterestRateV1;
    /**
     * 
     * @type {BundleDiscountV1}
     * @memberof CampaignSpecificationV1
     */
    'bundleDiscount'?: BundleDiscountV1;
    /**
     * 
     * @type {number}
     * @memberof CampaignSpecificationV1
     */
    'maxPeriodInMonths'?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignSpecificationV1
     */
    'maxProductCountIndividual'?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignSpecificationV1
     */
    'maxProductCountDriver'?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignSpecificationV1
     */
    'maxProductCountPassenger'?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignSpecificationV1
     */
    'maxProductCountChild'?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignSpecificationV1
     */
    'minAgeLimit'?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignSpecificationV1
     */
    'maxAgeLimit'?: number;
    /**
     * 
     * @type {CampaignDescriptionV1}
     * @memberof CampaignSpecificationV1
     */
    'campaignDescription'?: CampaignDescriptionV1;
    /**
     * 
     * @type {string}
     * @memberof CampaignSpecificationV1
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignSpecificationV1
     */
    'activeFrom': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignSpecificationV1
     */
    'activeTo': string;
    /**
     * 
     * @type {CampaignStatusV1}
     * @memberof CampaignSpecificationV1
     */
    'specificationStatus': CampaignStatusV1;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const CampaignStatusV1 = {
    ACTIVE: 'ACTIVE',
    SCHEDULED: 'SCHEDULED',
    EXPIRED: 'EXPIRED',
    FAILED: 'FAILED',
    CANCELED: 'CANCELED'
} as const;

export type CampaignStatusV1 = typeof CampaignStatusV1[keyof typeof CampaignStatusV1];


/**
 * 
 * @export
 * @interface EligibleCampaignV1
 */
export interface EligibleCampaignV1 {
    /**
     * 
     * @type {string}
     * @memberof EligibleCampaignV1
     */
    'campaignCode': string;
    /**
     * 
     * @type {string}
     * @memberof EligibleCampaignV1
     */
    'campaignName'?: string;
    /**
     * 
     * @type {string}
     * @memberof EligibleCampaignV1
     */
    'campaignFeTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof EligibleCampaignV1
     */
    'campaignFeName'?: string;
    /**
     * 
     * @type {string}
     * @memberof EligibleCampaignV1
     */
    'eligibleFrom': string;
    /**
     * 
     * @type {string}
     * @memberof EligibleCampaignV1
     */
    'eligibleTo': string;
    /**
     * 
     * @type {number}
     * @memberof EligibleCampaignV1
     */
    'numberOfRedeemedClients'?: number;
    /**
     * 
     * @type {Array<RedeemedClientV1>}
     * @memberof EligibleCampaignV1
     */
    'redeemedClients'?: Array<RedeemedClientV1>;
}
/**
 * 
 * @export
 * @interface InterestRateDefinitionV1
 */
export interface InterestRateDefinitionV1 {
    /**
     * 
     * @type {number}
     * @memberof InterestRateDefinitionV1
     */
    'value': number;
    /**
     * 
     * @type {number}
     * @memberof InterestRateDefinitionV1
     */
    'maxThresholdAmount'?: number;
    /**
     * 
     * @type {string}
     * @memberof InterestRateDefinitionV1
     */
    'validFrom': string;
    /**
     * 
     * @type {string}
     * @memberof InterestRateDefinitionV1
     */
    'validTo': string;
}
/**
 * 
 * @export
 * @interface InterestRateShortV1
 */
export interface InterestRateShortV1 {
    /**
     * 
     * @type {number}
     * @memberof InterestRateShortV1
     */
    'value': number;
}
/**
 * 
 * @export
 * @interface InterestRateV1
 */
export interface InterestRateV1 {
    /**
     * 
     * @type {string}
     * @memberof InterestRateV1
     */
    'code': string;
    /**
     * 
     * @type {Array<InterestRateDefinitionV1>}
     * @memberof InterestRateV1
     */
    'definitions': Array<InterestRateDefinitionV1>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const LanguageV1 = {
    CS: 'CS',
    EN: 'EN'
} as const;

export type LanguageV1 = typeof LanguageV1[keyof typeof LanguageV1];


/**
 * 
 * @export
 * @interface MarketingCampaignsFilterV1
 */
export interface MarketingCampaignsFilterV1 {
    /**
     * 
     * @type {LanguageV1}
     * @memberof MarketingCampaignsFilterV1
     */
    'language': LanguageV1;
    /**
     * 
     * @type {Array<AffectedCampaignTypeRequestV1>}
     * @memberof MarketingCampaignsFilterV1
     */
    'affectedSpecificationTypes'?: Array<AffectedCampaignTypeRequestV1>;
    /**
     * 
     * @type {Array<CampaignStatusV1>}
     * @memberof MarketingCampaignsFilterV1
     */
    'specificationStatuses'?: Array<CampaignStatusV1>;
}


/**
 * 
 * @export
 * @interface MarketingCampaignsV1
 */
export interface MarketingCampaignsV1 {
    /**
     * 
     * @type {Array<CampaignListItemV1>}
     * @memberof MarketingCampaignsV1
     */
    'campaigns': Array<CampaignListItemV1>;
}
/**
 * 
 * @export
 * @interface RedeemedClientV1
 */
export interface RedeemedClientV1 {
    /**
     * The UUID of the PID.
     * @type {string}
     * @memberof RedeemedClientV1
     */
    'pidUuid': string;
    /**
     * 
     * @type {string}
     * @memberof RedeemedClientV1
     */
    'redeemedAt': string;
    /**
     * 
     * @type {string}
     * @memberof RedeemedClientV1
     */
    'fullName'?: string;
}
/**
 * 
 * @export
 * @interface RedeemersByEligibleCampaignResponseV1
 */
export interface RedeemersByEligibleCampaignResponseV1 {
    /**
     * Client code for the PID.
     * @type {string}
     * @memberof RedeemersByEligibleCampaignResponseV1
     */
    'clientCode': string;
    /**
     * 
     * @type {Array<EligibleCampaignV1>}
     * @memberof RedeemersByEligibleCampaignResponseV1
     */
    'eligibleCampaigns': Array<EligibleCampaignV1>;
}


/**
 * MarketingCampaignsApi - axios parameter creator
 * @export
 */
export const MarketingCampaignsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Gets specification detail of a marketing campaign for a given client (PID).
         * @param {string} pidUuid Parameter for unique identifier of a user (Partners identity). 
         * @param {CampaignSpecificationDetailIdentificationV1} campaignSpecificationDetailIdentificationV1 
         * @param {string} [xCorrelationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketingCampaignSpecificationV1: async (pidUuid: string, campaignSpecificationDetailIdentificationV1: CampaignSpecificationDetailIdentificationV1, xCorrelationId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pidUuid' is not null or undefined
            assertParamExists('getMarketingCampaignSpecificationV1', 'pidUuid', pidUuid)
            // verify required parameter 'campaignSpecificationDetailIdentificationV1' is not null or undefined
            assertParamExists('getMarketingCampaignSpecificationV1', 'campaignSpecificationDetailIdentificationV1', campaignSpecificationDetailIdentificationV1)
            const localVarPath = `/bank-backofficegateway-campaigns-external/v1/pid/{pidUuid}/marketing-campaigns/specification-detail`
                .replace(`{${"pidUuid"}}`, encodeURIComponent(String(pidUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignSpecificationDetailIdentificationV1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets marketing campaigns for a given client (PID).
         * @param {string} pidUuid Parameter for unique identifier of a user (Partners identity). 
         * @param {MarketingCampaignsFilterV1} marketingCampaignsFilterV1 
         * @param {string} [xCorrelationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketingCampaignsV1: async (pidUuid: string, marketingCampaignsFilterV1: MarketingCampaignsFilterV1, xCorrelationId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pidUuid' is not null or undefined
            assertParamExists('getMarketingCampaignsV1', 'pidUuid', pidUuid)
            // verify required parameter 'marketingCampaignsFilterV1' is not null or undefined
            assertParamExists('getMarketingCampaignsV1', 'marketingCampaignsFilterV1', marketingCampaignsFilterV1)
            const localVarPath = `/bank-backofficegateway-campaigns-external/v1/pid/{pidUuid}/marketing-campaigns`
                .replace(`{${"pidUuid"}}`, encodeURIComponent(String(pidUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(marketingCampaignsFilterV1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets clientCode and redeemers for eligible campaign for given PID.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid Parameter for unique identifier of a user (Partners identity). 
         * @param {LanguageV1} language Query parameter for language. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedeemersByEligibleCampaignV1: async (xCorrelationId: string, pidUuid: string, language: LanguageV1, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getRedeemersByEligibleCampaignV1', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'pidUuid' is not null or undefined
            assertParamExists('getRedeemersByEligibleCampaignV1', 'pidUuid', pidUuid)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('getRedeemersByEligibleCampaignV1', 'language', language)
            const localVarPath = `/bank-backofficegateway-campaigns-external/v1/pid/{pidUuid}/redeemers-by-eligible-campaign`
                .replace(`{${"pidUuid"}}`, encodeURIComponent(String(pidUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MarketingCampaignsApi - functional programming interface
 * @export
 */
export const MarketingCampaignsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MarketingCampaignsApiAxiosParamCreator(configuration)
    return {
        /**
         * Gets specification detail of a marketing campaign for a given client (PID).
         * @param {string} pidUuid Parameter for unique identifier of a user (Partners identity). 
         * @param {CampaignSpecificationDetailIdentificationV1} campaignSpecificationDetailIdentificationV1 
         * @param {string} [xCorrelationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMarketingCampaignSpecificationV1(pidUuid: string, campaignSpecificationDetailIdentificationV1: CampaignSpecificationDetailIdentificationV1, xCorrelationId?: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignSpecificationDetailV1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMarketingCampaignSpecificationV1(pidUuid, campaignSpecificationDetailIdentificationV1, xCorrelationId, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets marketing campaigns for a given client (PID).
         * @param {string} pidUuid Parameter for unique identifier of a user (Partners identity). 
         * @param {MarketingCampaignsFilterV1} marketingCampaignsFilterV1 
         * @param {string} [xCorrelationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMarketingCampaignsV1(pidUuid: string, marketingCampaignsFilterV1: MarketingCampaignsFilterV1, xCorrelationId?: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketingCampaignsV1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMarketingCampaignsV1(pidUuid, marketingCampaignsFilterV1, xCorrelationId, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets clientCode and redeemers for eligible campaign for given PID.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid Parameter for unique identifier of a user (Partners identity). 
         * @param {LanguageV1} language Query parameter for language. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRedeemersByEligibleCampaignV1(xCorrelationId: string, pidUuid: string, language: LanguageV1, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RedeemersByEligibleCampaignResponseV1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRedeemersByEligibleCampaignV1(xCorrelationId, pidUuid, language, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MarketingCampaignsApi - factory interface
 * @export
 */
export const MarketingCampaignsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MarketingCampaignsApiFp(configuration)
    return {
        /**
         * Gets specification detail of a marketing campaign for a given client (PID).
         * @param {MarketingCampaignsApiGetMarketingCampaignSpecificationV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketingCampaignSpecificationV1(requestParameters: MarketingCampaignsApiGetMarketingCampaignSpecificationV1Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<CampaignSpecificationDetailV1> {
            return localVarFp.getMarketingCampaignSpecificationV1(requestParameters.pidUuid, requestParameters.campaignSpecificationDetailIdentificationV1, requestParameters.xCorrelationId, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Gets marketing campaigns for a given client (PID).
         * @param {MarketingCampaignsApiGetMarketingCampaignsV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketingCampaignsV1(requestParameters: MarketingCampaignsApiGetMarketingCampaignsV1Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<MarketingCampaignsV1> {
            return localVarFp.getMarketingCampaignsV1(requestParameters.pidUuid, requestParameters.marketingCampaignsFilterV1, requestParameters.xCorrelationId, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Gets clientCode and redeemers for eligible campaign for given PID.
         * @param {MarketingCampaignsApiGetRedeemersByEligibleCampaignV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedeemersByEligibleCampaignV1(requestParameters: MarketingCampaignsApiGetRedeemersByEligibleCampaignV1Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<RedeemersByEligibleCampaignResponseV1> {
            return localVarFp.getRedeemersByEligibleCampaignV1(requestParameters.xCorrelationId, requestParameters.pidUuid, requestParameters.language, options, endpointOptions).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getMarketingCampaignSpecificationV1 operation in MarketingCampaignsApi.
 * @export
 * @type MarketingCampaignsApiGetMarketingCampaignSpecificationV1Request
 */
export type MarketingCampaignsApiGetMarketingCampaignSpecificationV1Request = {
    /**
     * Parameter for unique identifier of a user (Partners identity). 
     * @type {string}
     * @memberof MarketingCampaignsApiGetMarketingCampaignSpecificationV1
     */
    readonly pidUuid: string

    /**
     * 
     * @type {CampaignSpecificationDetailIdentificationV1}
     * @memberof MarketingCampaignsApiGetMarketingCampaignSpecificationV1
     */
    readonly campaignSpecificationDetailIdentificationV1: CampaignSpecificationDetailIdentificationV1

    /**
     * 
     * @type {string}
     * @memberof MarketingCampaignsApiGetMarketingCampaignSpecificationV1
     */
    readonly xCorrelationId?: string
}

/**
 * Request parameters for getMarketingCampaignsV1 operation in MarketingCampaignsApi.
 * @export
 * @type MarketingCampaignsApiGetMarketingCampaignsV1Request
 */
export type MarketingCampaignsApiGetMarketingCampaignsV1Request = {
    /**
     * Parameter for unique identifier of a user (Partners identity). 
     * @type {string}
     * @memberof MarketingCampaignsApiGetMarketingCampaignsV1
     */
    readonly pidUuid: string

    /**
     * 
     * @type {MarketingCampaignsFilterV1}
     * @memberof MarketingCampaignsApiGetMarketingCampaignsV1
     */
    readonly marketingCampaignsFilterV1: MarketingCampaignsFilterV1

    /**
     * 
     * @type {string}
     * @memberof MarketingCampaignsApiGetMarketingCampaignsV1
     */
    readonly xCorrelationId?: string
}

/**
 * Request parameters for getRedeemersByEligibleCampaignV1 operation in MarketingCampaignsApi.
 * @export
 * @type MarketingCampaignsApiGetRedeemersByEligibleCampaignV1Request
 */
export type MarketingCampaignsApiGetRedeemersByEligibleCampaignV1Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof MarketingCampaignsApiGetRedeemersByEligibleCampaignV1
     */
    readonly xCorrelationId: string

    /**
     * Parameter for unique identifier of a user (Partners identity). 
     * @type {string}
     * @memberof MarketingCampaignsApiGetRedeemersByEligibleCampaignV1
     */
    readonly pidUuid: string

    /**
     * Query parameter for language. 
     * @type {LanguageV1}
     * @memberof MarketingCampaignsApiGetRedeemersByEligibleCampaignV1
     */
    readonly language: LanguageV1
}

/**
 * MarketingCampaignsApi - object-oriented interface
 * @export
 * @class MarketingCampaignsApi
 * @extends {BaseAPI}
 */
export class MarketingCampaignsApi extends BaseAPI {
    /**
     * Gets specification detail of a marketing campaign for a given client (PID).
     * @param {MarketingCampaignsApiGetMarketingCampaignSpecificationV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketingCampaignsApi
     */
    public getMarketingCampaignSpecificationV1(requestParameters: MarketingCampaignsApiGetMarketingCampaignSpecificationV1Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return MarketingCampaignsApiFp(this.configuration).getMarketingCampaignSpecificationV1(requestParameters.pidUuid, requestParameters.campaignSpecificationDetailIdentificationV1, requestParameters.xCorrelationId, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets marketing campaigns for a given client (PID).
     * @param {MarketingCampaignsApiGetMarketingCampaignsV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketingCampaignsApi
     */
    public getMarketingCampaignsV1(requestParameters: MarketingCampaignsApiGetMarketingCampaignsV1Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return MarketingCampaignsApiFp(this.configuration).getMarketingCampaignsV1(requestParameters.pidUuid, requestParameters.marketingCampaignsFilterV1, requestParameters.xCorrelationId, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets clientCode and redeemers for eligible campaign for given PID.
     * @param {MarketingCampaignsApiGetRedeemersByEligibleCampaignV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketingCampaignsApi
     */
    public getRedeemersByEligibleCampaignV1(requestParameters: MarketingCampaignsApiGetRedeemersByEligibleCampaignV1Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return MarketingCampaignsApiFp(this.configuration).getRedeemersByEligibleCampaignV1(requestParameters.xCorrelationId, requestParameters.pidUuid, requestParameters.language, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }
}


